export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 20
    },
    {
      prop: 'name',
      label: '车主名',
      minWidth: 150
    },
    {
      prop: 'insbill',
      label: '参保项目',
      minWidth: 30,
    },
    {
      prop: 'create_time',
      label: '创建时间',
      minWidth: 100,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}